import { z } from 'zod';
export const TIPOS_CLASE_TARIFA = ['PRIVADA', 'GRUPAL', 'EMPRESA'];
export const MODOS_PRECIO = ['POR_GRUPO', 'POR_PERSONA'];
export const TarifaFullSchema = z.object({
    id: z.string().uuid(),
    sucursalId: z.string().uuid().optional(),
    nombre: z.string(),
    tipoClase: z.string(),
    disciplina: z.string().nullable().optional(),
    cantPersonasMin: z.number().nullable().optional(),
    cantPersonasMax: z.number().nullable().optional(),
    duracionHoras: z.union([z.string(), z.number()]).nullable().optional(),
    modoPrecio: z.string().nullable().optional(),
    precio: z.union([z.string(), z.number()]).nullable().optional(),
    incluyeEquipo: z.boolean().optional(),
    vigenteDesde: z.string().nullable().optional(),
    vigenteHasta: z.string().nullable().optional(),
    visibleWeb: z.boolean().optional(),
    color: z
        .string()
        .regex(/^#[0-9A-Fa-f]{6}$/)
        .nullable()
        .optional(),
    activo: z.boolean(),
});
export const TarifaFormSchema = z.object({
    nombre: z.string().trim().min(1, 'Requerido').max(150),
    tipoClase: z.enum(TIPOS_CLASE_TARIFA),
    disciplina: z.string().optional().or(z.literal('')),
    cantPersonasMin: z.coerce.number().int().min(1).max(50),
    cantPersonasMax: z.coerce.number().int().min(1).max(50),
    duracionHoras: z.string().regex(/^\d{1,2}(\.\d{1,2})?$/, 'Ej. 2 o 2.5'),
    modoPrecio: z.enum(MODOS_PRECIO),
    precio: z.string().regex(/^\d+(\.\d{1,2})?$/, 'Monto inválido'),
    incluyeEquipo: z.boolean().default(false),
    vigenteDesde: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'YYYY-MM-DD'),
    vigenteHasta: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'YYYY-MM-DD')
        .optional()
        .or(z.literal('')),
    visibleWeb: z.boolean().default(false),
    color: z
        .string()
        .regex(/^#[0-9A-Fa-f]{6}$/, 'Color inválido (usá #RRGGBB)')
        .optional()
        .or(z.literal('')),
});
